import { checkLength } from './index'
import store from '@/store'
import _, { some } from 'lodash'
/**
 * rule 隐射
 * 解析 - 自定义
 */
const ruleMap = {
    valueAttributeRule: (ruleValue) => {
        return {}
    },
    // valueTypeRule，用于描述field值需要满足数据类型，包括了text（文本型）/decimal（小数型）/integer（整数型）/date（日期型）/long（长整数型）/url（超链接）/textarea（多行文本）/html（支持html标记语法的文本）
    valueTypeRule: (ruleValue, fieldItem) => {
        // multi_enum 类型：材质成分等特殊多选+枚举值字段
        if (ruleValue === 'multi_enum') {
            return {
                validator(rule, value, callback) {
                    if (!value) {
                        // 检查是否必填
                        if (fieldItem._oriRules?.required === 'true') {
                            callback(new Error('请至少选择一种材质'))
                            return
                        }
                        callback()
                        return
                    }
                    try {
                        let list
                        if (typeof value === 'string') {
                            list = JSON.parse(value)
                        } else if (Array.isArray(value)) {
                            list = value
                        } else {
                            callback()
                            return
                        }
                        if (!Array.isArray(list)) {
                            callback()
                            return
                        }
                        // 过滤有效项（有value的）
                        const validItems = list.filter(item => item && item.value)
                        if (validItems.length === 0) {
                            if (fieldItem._oriRules?.required === 'true') {
                                callback(new Error('请至少选择一种材质'))
                                return
                            }
                            callback()
                            return
                        }
                        // 检查最大数量
                        const maxLength = Number(fieldItem._oriRules?.maxLengthRule) || 7
                        if (validItems.length > maxLength) {
                            callback(new Error(`最多可选${maxLength}种材质`))
                            return
                        }
                        // 检查是否有填写含量的
                        const hasPercent = validItems.some(item => {
                            if (!item.text) return false
                            const match = item.text.match(/:(\d+\.?\d*)%$/)
                            return match && parseFloat(match[1]) > 0
                        })
                        if (hasPercent) {
                            // 计算总占比
                            let total = 0
                            let hasError = false
                            validItems.forEach(item => {
                                if (!item.text) return
                                const match = item.text.match(/:(\d+\.?\d*)%$/)
                                if (match) {
                                    total += parseFloat(match[1])
                                }
                            })
                            // 允许 0.01 的误差
                            if (Math.abs(total - 100) > 0.01) {
                                callback(new Error(`材质含量总和必须等于100%，当前为${total.toFixed(2)}%`))
                                hasError = true
                            }
                            if (!hasError) {
                                callback()
                            }
                        } else {
                            callback()
                        }
                    } catch (e) {
                        callback()
                    }
                }
            }
        }
        // 暂时不处理
        return {}
    },
    // requiredRule，是否必填，默认为false，true/false
    // requiredRule: (ruleValue, fieldItem) => {
       
    //     return {
    //         required: ruleValue === 'true',
    //         message: '必填'
    //     }
    // },
    required: (ruleValue, fieldItem) => {
        if (fieldItem.name === 'upshelfTime') { // 上架时间
            return {
                required: ruleValue === 'true',
                validator(rule, value, callback){
                    if(!value) {
                        callback('必填')
                    }
                    if(value === '2') {
                        const upshelfTime_date = store.getters.alibabaForm.upshelfTime_date
                        if(!upshelfTime_date) {
                            callback('请填写定时开售时间')
                        }
                    }
                    callback()
                },
            }
        } else if(fieldItem.name === 'kf') {
            return {
                // required: ruleValue === 'true',
                validator(rule, value, callback){
                    const alibabaForm = store.getters.alibabaForm
                    const disabled = !((alibabaForm.supplyType || []).includes('2') && alibabaForm.isSupportQuickBackInventory)
                    if(!value && ruleValue === 'true' && !disabled) {
                        callback('必填')
                    } else {
                        callback()
                    }
                },
            }
        }
        return {
            required: ruleValue === 'true',
            message: '必填'
        }
    },
    // disableRule，是否忽略此field，为true时，将不对rule进行check，同时他的value也将无效。默认为false，值范围包含true/false
    disableRule: () => {
        return {}
    },
    // maxLengthRule ，最大长度
    maxLengthRule: (ruleValue, fieldItem, rule) => {
        const isCatProp = fieldItem.parentName === 'catProp' // 是否是类目属性下的控件
        // 暂时只处理input类型
        if (fieldItem.type !== 'INPUT') return {}
        if (fieldItem.rules.unit === 'byte') {
            return {
                validator(rule, value) {
                    if (checkLength(value) > ruleValue) {
                        return Promise.reject(
                            new Error('长度不能大于' + ruleValue + '字节(汉字占2字节，英文占1字节)')
                        )
                    }
                    return Promise.resolve()
                }
            }
        }

        return {
            type: 'string',
            max: parseInt(ruleValue, 10),
            message: '文字长度不能大于' + ruleValue + '字符'
        }
    },
    // minLengthRule ，最小长度
    minLengthRule: (ruleValue, fieldItem) => {
        const isCatProp = fieldItem.parentName === 'catProp' // 是否是类目属性下的控件
        // 暂时只处理input类型，其实多选单休如果出现input也需要验证
        if (fieldItem.type !== 'INPUT') return {}

        if (fieldItem.rules.unit === 'byte') {
            return {
                validator(rule, value) {
                    if (checkLength(value) < ruleValue) {
                        return Promise.reject(
                            new Error('长度不能小于' + ruleValue + '字节(汉字占2字节，英文占1字节)')
                        )
                    }
                    return Promise.resolve()
                }
            }
        }

        return {
            type: 'string',
            min: parseInt(ruleValue, 10),
            message: '文字长度不能小于' + ruleValue + '字符'
        }
    },
    // maxValueRule，最大值（数值类型或数组时有效）
    maxValueRule: (ruleValue, fieldItem) => {
        if (ruleValue === 'date') {
            return {}
        } else {
            if (isNaN(Number(ruleValue))) {
                return {}
            }
            if (fieldItem.exProperty === 'include') {
                // 包含
                if (fieldItem.type === 'MULTICHECK') {
                    return {
                        type: 'array',
                        max: parseInt(ruleValue, 10),
                        message: '最多可选' + ruleValue
                    }
                } else {
                    return {
                        type: 'number',
                        max: parseFloat(ruleValue, 10),
                        message: '值不能大于' + ruleValue
                    }
                }
            } else {
                // 不包含
                return {
                    validator(rule, value, callback) {
                        if (!value) {
                            return Promise.resolve();
                        }
                        const isArray = value instanceof Array
                        if (value && !isArray && isNaN(Number(value))) {
                            return Promise.reject(new Error('请输入数字'))
                        }
                        if (parseFloat(isArray ? value.length : value, 10) <= parseFloat(ruleValue, 10)) {
                            return Promise.resolve()
                        } else {
                            return Promise.reject(
                                isArray ? new Error('最多只能选择' + ruleValue + '个值')
                                    : new Error('值不能大于' + ruleValue)
                            )
                        }
                    }
                }
            }
        }
    },
    // minValueRule ，最小值（数值类型或数组时有效）
    minValueRule: (ruleValue, fieldItem) => {
        if (fieldItem.valueTypeRule === 'date') {
            return {}
        } else {
            if (isNaN(Number(ruleValue))) {
                return {}
            }

            if (fieldItem.exProperty === 'include') {
                // 包含
                if (fieldItem.type === 'MULTICHECK') {
                    return {
                        type: 'array',
                        min: parseInt(ruleValue, 10),
                        message: '至少要选' + ruleValue
                    }
                } else {
                    return {
                        type: 'number',
                        min: parseFloat(ruleValue, 10),
                        message: '值不能小于' + ruleValue
                    }
                }
            } else {
                // 不包含
                return {
                    validator(rule, value, callback) {
                        if (!value) {
                            return Promise.resolve();
                        }
                        const isArray = value instanceof Array
                        if (!isArray && isNaN(Number(value))) {
                            return Promise.reject(new Error('请输入数字'))
                        }
                        if (parseFloat(isArray ? value.length : value, 10) >= parseFloat(ruleValue, 10)) {
                            return Promise.resolve()
                        } else {
                            return Promise.reject(
                                isArray ? new Error('最少选择' + ruleValue + '个值')
                                    : new Error('值不能小于' + ruleValue)
                            )
                        }
                    }
                }
            }
        }
    },
    // maxInputNumRule ，最多可选数（多选时有效）
    maxInputNumRule: (ruleValue) => {
        return {
            type: 'array',
            max: parseInt(ruleValue, 10),
            message: '最多可选' + ruleValue
        }
    },
    // minInputNumRule ，至少要选数（多选时有效）
    minInputNumRule: (ruleValue) => {
        return {
            type: 'array',
            min: parseInt(ruleValue, 10),
            message: '至少要选' + ruleValue
        }
    },
    // maxTargetSizeRule ，最大目标文件大小
    maxTargetSizeRule: (ruleValue) => {
        const fileSize = Math.round((ruleValue / 1024 / 1024) * 100) / 100
        return {}
        // return {
        //     prop: {
        //         maxSize: fileSize
        //     },
        //     tipRule: '最大文件大小: ' + fileSize + '(m)'
        // }
    },
    // minTargetSizeRule ，最小目标文件大小
    minTargetSizeRule: (ruleValue) => {
        const fileSize = Math.round((ruleValue / 1024 / 1024) * 100) / 100
        return {
            prop: {
                maxSize: fileSize
            },
            tipRule: '最小文件大小: ' + fileSize + '(m)'
        }
    },
    // readOnlyRule ，只读，用户无法修改返回值，值范围为true/false
    readOnlyRule: (ruleValue) => {
        if (ruleValue === 'true') {
            return {
                prop: {
                    disabled: true
                }
            }
        }
        return
    },
    // regxRule ， 正则表达式匹配
    regexRule: (ruleValue) => {
        if (ruleValue === 'date') {
            return {}
        } else {
            let _ruleValue = ruleValue.replaceAll('\\.', '\\.')
            return {
                pattern: new RegExp(`^${_ruleValue}$`),
                message: `请填写正确值: ${_ruleValue}`
            }
        }
    },
    // tipRule ，Field中展示的tip信息，用于一些无法直接用语法描述或者过于复杂的规则，或者提示信息,需要给用户透出。
    tipRule: (ruleValue) => {
        const tipRule = ruleValue.split(';')
        if (tipRule.length >= 0) {
            return tipRule
        } else {
            return []
        }
    },
    // maxImageSizeRule，最大图片大小，指的是分辨率，如800*800
    maxImageSizeRule: (ruleValue) => {
        const Size = ruleValue.split('x')

        return {
            prop: {
                maxWidth: parseInt(Size[0], 10),
                maxHeight: parseInt(Size[1], 10)
            },
            tipRule: '最大图片大小: ' + ruleValue
        }
    },
    // minImageSizeRule ， 最小图片大小
    minImageSizeRule: (ruleValue) => {
        const Size = ruleValue.split('x')

        return {
            prop: {
                minWidth: parseInt(Size[0], 10),
                minHeight: parseInt(Size[1], 10)
            },
            tipRule: '最小图片大小: ' + ruleValue
        }
    },
    // +devTipRule，一般用于给开发者提示，不需要展示给用户，开发者可以通过此Rule获取特定的信息，如例子中的如何获取售后模板信息。
    devTipRule: () => { return {} },
    asyncRenderRule: () => { return {} },
    maxItemsRule: () => { return {} },
    unitTypeRule: () => { return {} },
    unit: () => { return {} }, // 用不到 防止报错
}


const validatePriceRange = (rule, value, callback) => {
    let list = value ? JSON.parse(value) : []
    if(!Array.isArray(list)) {
        list = []
    }
    let errMag = ''
    list.find((item, index) => {
        const { pricerange_beginAmount, pricerange_price } = item || {}
        const preItem = list[index - 1]
        if(!item.pricerange_beginAmount || !item.pricerange_price) {
            errMag = '区间报价填写不完整'
            return true
        }
        if(preItem) {
            if(pricerange_beginAmount <= preItem.pricerange_beginAmount) {
                errMag = '“购买数量” 必须后者大于前者'
                return true
            }
            if(pricerange_price >= preItem.pricerange_price) {
                errMag = '“单价”必须下面值小于上面值'
                return true
            }
        }
    })
    if (errMag) {
        callback(new Error(errMag))
    } else {
        callback();
    }
}

/**
 * 匹配生成rule规则
 * 遍历 - 匹配
 * @param {*} rule 
 */
const buildRules = (rulesKeys, rules = {}, field) => {
    return rulesKeys.reduce((item, key) => {

        const rule = ruleMap[key] ? ruleMap[key](rules[key], field, rules) : {};

        if (_.isEmpty(rule)) return item // 处理返回空对象的类型 {}

        if (key === 'tipRule') {
            field['tipRule'] = rule
            return item
        } else {
            return item.concat([rule])
        }
    }, [])
}

/**
 * 获取 rules
 * 判空 - 转数组
 * @param {*} rules 
 * @returns 
 */
export const getRules = (field) => {
    let { name, rules } = field
    rules = rules || {}
    if (Array.isArray(rules)) return rules // 如果已经是了直接返回
    if(name === 'catProp') return
    if (name === 'priceRange') {
        return [{ validator: validatePriceRange }]
    }

    if(name === 'title') {
        rules.unit = 'byte'
    }
    const rulesKeys = Object.keys(rules)
    if (rulesKeys.length <= 0) return []
    field._oriRules = rules;
    return buildRules(rulesKeys, rules, field)
}

/**
 * 获取多实例复合型表单的校验
 * @param {*} field 
 */
export const getMultiComplexRules = (field) => {
    const { rules = {}, label } = field
    if (Array.isArray(rules)) return field.rules // 如果已经是了直接返回

    let _rules = []
    if (rules.requiredRule && rules.requiredRule === 'true') {
        _rules.push({
            required: true,
            validator: (rule, value, cb) => {
                if (!value || !value.length) {
                    cb(new Error(`${label}必填一份数据`))
                } else {

                    let hasVoid = value.some((item) => {
                        return Object.values(item).some(v => (v === undefined || v === ''))
                    });
                    hasVoid ? cb(new Error(`${label}子项请勿留空`)) : cb()
                }
            },
        })
    }
    if (rules.maxInputNumRule) {
        _rules.push({
            validator: (rule, value, cb) => {
                if (value && value.length > Number(rules.maxInputNumRule)) {
                    cb(new Error(`不能超过${rules.maxInputNumRule}份数据`))
                } else {
                    cb()
                }
            },
        })
    }
    return _rules;
}
